import { jsxs as d, jsx as c } from "react/jsx-runtime";
import { E as v, S as f } from "./icons.types-0722eef5.js";
function u({ title: i, titleId: n, size: l, width: o, height: t, extended: h = !1, ...a }) {
  const r = h ? v : f, s = l ? r[l] : o || r[h ? "s" : "l"], e = l ? r[l] : t || r[h ? "s" : "l"];
  return /* @__PURE__ */ d(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: s,
      height: e,
      "aria-labelledby": n,
      ...a,
      children: [
        i ? /* @__PURE__ */ c("title", { id: n, children: i }) : null,
        /* @__PURE__ */ c("g", { clipPath: "url(#Car_Front_svg__a)", children: /* @__PURE__ */ c(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M45.88 9c5.544 0 9.166 3.227 11.193 9.002l2.154 5.413h5.057c3.4 0 6.216 2.958 6.216 6.602 0 2.9-1.785 5.367-4.228 6.252a9.717 9.717 0 0 1 2.063 5.986v14.143c0 3.656-2.55 6.602-5.946 6.602h-4.33c-3.289 0-5.783-2.762-5.938-6.255H19.879C19.724 60.238 17.23 63 13.941 63h-4.33c-3.396 0-5.946-2.946-5.946-6.602V42.255c0-2.182.733-4.307 2.064-5.986-2.444-.885-4.229-3.351-4.229-6.252 0-3.644 2.816-6.602 6.216-6.602h5.057l2.163-5.434C17.389 11.994 20.674 9 26.12 9h19.758Zm0 4.5H26.12c-3.45 0-5.378 1.758-7.21 6.229l-2.707 6.799c-.334.84-1.12 1.387-1.991 1.387H7.716c-1.012 0-1.904.936-1.904 2.102 0 1.165.892 2.101 1.904 2.101h2.165c1.795 0 2.804 2.155 1.702 3.633L9.104 39.07a5.098 5.098 0 0 0-1.126 3.185v14.143c0 1.267.722 2.102 1.633 2.102h4.33c.911 0 1.633-.835 1.633-2.102v-1.904c0-1.242.966-2.25 2.156-2.25h36.54c1.19 0 2.156 1.008 2.156 2.25v1.904c0 1.267.722 2.102 1.633 2.102h4.33c.911 0 1.633-.835 1.633-2.102V42.255c0-1.14-.386-2.256-1.169-3.24l-2.436-3.264c-1.102-1.478-.093-3.633 1.702-3.633h2.165c1.012 0 1.903-.936 1.903-2.102 0-1.165-.89-2.101-1.903-2.101h-6.496c-.871 0-1.657-.547-1.991-1.387l-2.74-6.888c-1.485-4.229-3.631-6.14-7.178-6.14Zm.022 9.283c1.083-.517 2.363-.02 2.858 1.11l1.971 4.5c.653 1.49-.39 3.186-1.96 3.186H22.894c-1.57 0-2.614-1.695-1.96-3.185l1.97-4.5c.496-1.13 1.775-1.628 2.858-1.111 1.083.516 1.56 1.851 1.065 2.982l-.576 1.314h19.162l-.576-1.314c-.495-1.13-.019-2.466 1.064-2.982Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ c("defs", { children: /* @__PURE__ */ c("clipPath", { id: "Car_Front_svg__a", children: /* @__PURE__ */ c(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  u as CarFront
};
